import { ReactNode } from 'react';

interface StickyNoteProps {
    children: ReactNode;
    className?: string;
    rotation?: string;
}

export function StickyNote({ children, className = '', rotation = 'rotate-2' }: StickyNoteProps) {
    return (
        <div className={`relative bg-accent p-6 shadow-pop w-64 ${rotation} ${className}`}>
            {/* Tape effect */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-24 h-8 bg-white/40 rotate-1 backdrop-blur-sm shadow-sm" />

            <div className="font-hand text-xl text-zinc-900 text-center leading-relaxed">
                {children}
            </div>
        </div>
    );
}
